import { Attachment } from "./attachmentsModel"
import './AttachmentsGallery.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpRightFromSquare, faChevronLeft, faChevronRight, faRotateLeft, faRotateRight, faX } from "@fortawesome/pro-solid-svg-icons"
import { Space } from "antd"
import { useEffect, useState } from "react"
import { faImageSlash, faSpinner } from "@fortawesome/pro-duotone-svg-icons"
import ThemableButton from "../Items/ThemableButton"
import { grey } from "@ant-design/colors"
import { useKeyboardEvent } from "../../hooks/useKeyboardEvent"

type Props = {
  attachments: Attachment[]
  selectedIndex: number
  onIndexChange: (index?: number) => void
}

const AttachmentsGallery = ({attachments, selectedIndex, onIndexChange}: Props) => {
  const selected = attachments[selectedIndex]

  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [rotationAngle, setRotationAngle] = useState(0)

  useKeyboardEvent('keyup', key => {
    switch (key) {
      case 'ArrowLeft':
        navigate(-1)
        break
      case 'ArrowRight':
        navigate(1)
        break
      case 'Escape':
        onIndexChange(undefined)
        break
    }
  })

  useEffect(() => {
    setIsLoading(true)
    setIsError(false)
    setRotationAngle(0)
  }, [selectedIndex])

  const navigate = (add: number) => {
    let next = (selectedIndex + add) % attachments.length
    if (next < 0) {
      next = attachments.length - 1
    }
    onIndexChange(next)
  }

  const rotate = (addAngle: number) => {
    let newAngle = (rotationAngle + addAngle) % 360
    if (newAngle < 0) {
      newAngle = 360 + newAngle
    }
    setRotationAngle(newAngle)
  }

  const handleError = () => {
    setIsError(true)
    setIsLoading(false)
  }

  return <div className="attachments-gallery">
    <div className="gallery-display">
      <div className="gallery-image">
        {!isError && <img src={selected.url}
          onLoad={() => setIsLoading(false)}
          onError={() => handleError()}
          style={{transform: `rotate(${rotationAngle}deg)`}}
        />}
        {isError && <div className="gallery-image-error">
          <FontAwesomeIcon icon={faImageSlash} size="5x" />
          <br />
          <span>Error loading image</span>
        </div>}
      </div>
      {isLoading && <div className="gallery-image gallery-image-loading">
        <FontAwesomeIcon icon={faSpinner} size="9x" spin />
      </div>}
      <div className="attachment-navigation prev-attachment" onClick={() => navigate(-1)}>
        <FontAwesomeIcon icon={faChevronLeft} size="5x" />
      </div>
      <div className="attachment-navigation next-attachment" onClick={() => navigate(1)}>
        <FontAwesomeIcon icon={faChevronRight} size="5x" />
      </div>
    </div>
    <header className="info">
      <div className="corner-block"></div>
      <div>
        <ThemableButton type="link" onClick={() => rotate(-90)} colorLink={grey[2]}>
          <FontAwesomeIcon icon={faRotateLeft} />
        </ThemableButton>
        <ThemableButton type="link" onClick={() => rotate(90)} colorLink={grey[2]}>
          <FontAwesomeIcon icon={faRotateRight} />
        </ThemableButton>
      </div>
      <div className="corner-block right">
        <ThemableButton type="link" onClick={() => onIndexChange(undefined)} colorLink={grey[2]}>
          <Space>
            CLOSE
            <FontAwesomeIcon icon={faX} />
          </Space>
        </ThemableButton>
      </div>
    </header>
    <footer className="info">
      <div className="corner-block">{selectedIndex + 1} of {attachments.length}</div>
      <div className="centered">
        <div>
          {selected.name}
        </div>
        <ThemableButton type="link" onClick={() => window.open(selected.url, "_blank")} colorLink={grey[2]}>
          <Space>
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            OPEN IN NEW WINDOW
          </Space>
        </ThemableButton>
      </div>
      <div className="corner-block"></div>
    </footer>
  </div>
}

export default AttachmentsGallery